/* eslint-disable max-lines */
/* eslint-disable new-cap */
import moment from 'moment';
import React from 'react';
import {Popup} from 'semantic-ui-react';
import {noTimeZoneShortISODate, shortYearDate} from '../../../../common/constants/datesFormat';
import {solNacDigits} from '../../../constants/commons';
import {completeWithCeros} from '../../../utils/commonUtils';
import {FLOATING_DEALERS} from '../../../../budgetVehicles/constants';

export const tableHeaderWithProps = (isUserTde, dealerId) => [
  {
    'Header': () => <span className="floating-header-title">DÍAS EN <br/> DEPÓSITO</span>,
    'headerText': 'DÍAS EN DEPÓSITO',
    'accessor': 'daysInDeposit',
    'width': 150,
    'Cell': ({row}) => {
      const setBgColor = (row) => {
        if (row.original.daysOldDeposit > 90) {
          return 'red-color-floating';
        } else if (row.original.daysOldDeposit > 60) {
          return 'yellow-color-floating';
        }
        return 'green-color-floating';
      };
      const bgColor = setBgColor(row);
      return <div className={bgColor}>{row.original.daysInDeposit?.split('/')[0] || ''}</div>;
    },
  },
  {
    'Header': () => <span className="floating-header-title">ESTADO</span>,
    'headerText': 'ESTADO',
    'accessor': 'floatingStateText',
    'width': 150,
  },
  {
    'Header': () => (
      <span className="floating-header-title">N° SOLICITUD NACIONALIZACIÓN</span>
    ),
    'headerText': 'N° SOLICITUD NACIONALIZACIÓN',
    'accessor': 'solNacNumber',
    'width': 150,
    'Cell': ({row}) => (
      <>{`${['S', 'L', 'V'].includes(row.original.floatingState) ?
        completeWithCeros(
          String(row.original.solNacNumber || ''),
          solNacDigits) :
        ''}`}</>
    ),
  },
  {
    'Header': () => <span className="floating-header-title">PEDIDO</span>,
    'headerText': 'PEDIDO',
    'accessor': 'orderNumber',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">LÍNEA</span>,
    'headerText': 'LÍNEA',
    'accessor': 'line',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">DESCRIPCIÓN</span>,
    'headerText': 'DESCRIPCIÓN',
    'accessor': 'description',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">SFX</span>,
    'headerText': 'SFX',
    'accessor': 'sfx',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">COLOR EXTERNO</span>,
    'headerText': 'COLOR EXTERNO',
    'accessor': 'externalColor',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">CÓDIGO EXTERNO</span>,
    'headerText': 'CÓDIGO EXTERNO',
    'accessor': 'externalColorId',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">COLOR INTERNO</span>,
    'headerText': 'COLOR INTERNO',
    'accessor': 'internalColor',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">CÓDIGO INTERNO</span>,
    'headerText': 'CÓDIGO INTERNO',
    'accessor': 'internalColorId',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">CHASIS</span>,
    'headerText': 'CHASIS',
    'accessor': 'chassis',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">MOTOR</span>,
    'headerText': 'MOTOR',
    'accessor': 'motor',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">AÑO MODELO</span>,
    'headerText': 'AÑO MODELO',
    'accessor': 'yearModel',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">VALOR FOB</span>,
    'headerText': 'VALOR FOB',
    'accessor': 'fobValue',
    'width': 150,
    'Cell': ({row}) => {
      const dollarUS = Intl.NumberFormat('de-DE');
      return <>{`$ ${row.original?.fobValue ? dollarUS.format(row.original?.fobValue) : ''}`}</>;
    },
  },
  {
    'Header': () => <span className="floating-header-title">UBICACIÓN</span>,
    'headerText': 'UBICACIÓN',
    'accessor': 'locationText',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">FECHA LLEGADA</span>,
    'headerText': 'FECHA LLEGADA',
    'accessor': 'arrivalDate',
    'width': 150,
    'Cell': ({row}) => <>{row.original?.arrivalDate?.substring(0, 10) || ''}</>,
  },
  {
    'Header': () => (
      <span className="floating-header-title">FECHA DEPÓSITO</span>
    ),
    'headerText': 'FECHA DEPÓSITO',
    'accessor': 'depositDate',
    'width': 150,
    'Cell': ({row}) => <>{row.original?.depositDate?.substring(0, 10) || ''}</>,
  },
  {
    'Header': () => <span className="floating-header-title">DEALER</span>,
    'headerText': 'DEALER',
    'accessor': 'dealerName',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">ASESOR</span>,
    'headerText': 'ASESOR',
    'accessor': 'adviserName',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">CÉDULA CLIENTE</span>,
    'headerText': 'CÉDULA CLIENTE',
    'accessor': 'document',
    'width': 150,
    'Cell': ({row}) => (
      <>{(isUserTde || row.original.dealer === FLOATING_DEALERS.tde || dealerId === row.original.dealer) ?
        `${row.original.document || row.original.finalClient || ''}` :
        ''}
      </>
    ),
  },
  {
    'Header': () => <span className="floating-header-title">NOMBRE CLIENTE</span>,
    'headerText': 'NOMBRE CLIENTE',
    'accessor': 'clientName',
    'width': 150,
    'Cell': ({row}) => (
      <>{(isUserTde || row.original.dealer === FLOATING_DEALERS.tde || dealerId === row.original.dealer) ?
        (row.original.lastNames ? `${row.original.lastNames || ''} ${row.original.names || ''}` :
          `${row.original.finalClientName || ''}`) :
        ''}
      </>
    ),
  },
  {
    'Header': () => <span className="floating-header-title">% EXONERACIÓN</span>,
    'headerText': '% EXONERACIÓN',
    'accessor': 'exonerationPerc',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">TIPO DE NEGOCIO</span>,
    'headerText': 'TIPO DE NEGOCIO',
    'accessor': 'clientTypeText',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">AVANCE RESERVA</span>,
    'accessor': 'reserveAdvance',
    'headerText': 'AVANCE RESERVA',
    'width': 150,
    'Cell': ({row}) => {
      return (
        <>
          <Popup
            trigger={
              <span>
                {row?.original?.reserveAdvance}
              </span>
            }
            position="top center"
            size="small"
            disabled={!row?.original?.reserveAdvance}
            inverted
          >
            <Popup.Content style={{'fontSize': '9px'}}>
              <span>
                {row?.original?.reserveAdvanceText}
              </span>
            </Popup.Content>
          </Popup>
        </>
      );
    },
  },
  {
    'Header': () => <span className="floating-header-title">OBSERVACIONES</span>,
    'headerText': 'OBSERVACIONES',
    'accessor': 'observations',
    'width': 150,
    'className': 'cell-custom-inventory-models width-order-medium',
    'Cell': ({row}) => {
      return (
        <>
          <Popup
            trigger={
              <div className="dot">
                {row.original?.observations?.split('\n').length || 0}
              </div>
            }
            position="top center"
            size="small"
            className="observations-popup"
            disabled={!row?.original?.observations?.length}
            inverted
          >
            <Popup.Content style={{'fontSize': '9px'}}>
              <table>
                {row?.original?.observations
                  ?.split('\n')
                  .map((observation, index) => (
                    <span>
                      <th>{observation}</th>
                      <br />
                    </span>
                  ))}
              </table>
            </Popup.Content>
          </Popup>
        </>
      );
    },
  },
  {
    'Header': () => <span className="floating-header-title">DÍAS RESERVA</span>,
    'headerText': 'DÍAS RESERVA',
    'accessor': 'reservationDays',
    'width': 150,
  },
  {
    'Header': () => <span className="floating-header-title">FECHA RESERVA</span>,
    'headerText': 'FECHA RESERVA',
    'accessor': 'reservationFloatingDate',
    'width': 150,
    'Cell': ({row}) => <>{row.original.reservationFloatingDate?.substring(0, 10) || ''}</>,
  },
  {
    'Header': () => (
      <span className="floating-header-title">FECHA SOL. NACIONALIZACIÓN</span>
    ),
    'headerText': 'FECHA SOL. NACIONALIZACIÓN',
    'accessor': 'solNacDate',
    'width': 150,
    'Cell': ({row}) => <>{row.original.solNacDate?.substring(0, 10) || ''}</>,
    
  },
  {
    'Header': () => (
      <span className="floating-header-title">FECHA FACT. INFORMATIVA</span>
    ),
    'headerText': 'FECHA FACT. INFORMATIVA',
    'accessor': 'informBillDate',
    'width': 150,
    'Cell': ({row}) => <>{row.original.informBillDate?.substring(0, 10) || ''}</>,
  },
  {
    'Header': () => (
      <span className="floating-header-title">FECHA LIQUIDACIÓN</span>
    ),
    'headerText': 'FECHA LIQUIDACIÓN',
    'accessor': 'liqDate',
    'width': 150,
    'Cell': ({row}) => <>{row.original?.liqDate ? moment(row.original?.liqDate, noTimeZoneShortISODate)
      .format(noTimeZoneShortISODate) : ''}</>,
  },
  {
    'Header': () => (
      <span className="floating-header-title">DÍAS LIQUIDACIÓN</span>
    ),
    'headerText': 'DÍAS LIQUIDACIÓN',
    'accessor': 'daysLiqBilling',
    'width': 150,
  },
  {
    'Header': () => (
      <span className="floating-header-title">FECHA FACTURACIÓN</span>
    ),
    'headerText': 'FECHA FACTURACIÓN',
    'accessor': 'billingDate',
    'width': 150,
    'Cell': ({row}) => <>
      {
        (row.original?.billingDate && row.original.floatingStateText === 'FACTURADO') ?
          moment(row.original?.billingDate, shortYearDate).format(noTimeZoneShortISODate) :
          ''
      }
    </>,
  },
];
